var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ImageGallery',{attrs:{"initImages":_vm.images,"isPending":_vm.isPending},on:{"upload":_vm.onUpload,"delete":_vm.onDelete}})
}
var staticRenderFns = []

export { render, staticRenderFns }